/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ITiposUnidades from 'Infotrack@Modelos/smartStock/tiposUnidades/entidades/tiposUnidades';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import TiposUnidadesCM from '../controladorModelo/tiposUnidadesCM';
import { acciones, IEstadoTiposUnidades } from '../reductorTiposUnidades';
import TiposUnidadesVista from '../vista/tablaTiposUnidadesVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const tiposUnidadesCM = new TiposUnidadesCM();

const TableTiposUnidadesCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [tiposUnidadess, setTiposUnidadess] = React.useState<ITiposUnidades[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoTiposUnidades>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarTiposUnidades();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarTiposUnidades = () => {
        manejadorIndicadorCargaGlobal(true);
        tiposUnidadesCM.consultarTiposUnidadesPorFiltro({EmpresaId:idEmpresa}).then((tiposUnidadess) => {
            setTiposUnidadess(tiposUnidadess);
            manejadorIndicadorCargaGlobal(false);  
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadTiposUnidades?: ITiposUnidades) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadTiposUnidades, tipoFormulario } });
    };

    const confirmarEliminacion = (tiposUnidades: ITiposUnidades) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarTiposUnidades(tiposUnidades),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarTiposUnidades = (tiposUnidades: ITiposUnidades) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        tiposUnidadesCM.eliminarTiposUnidades(tiposUnidades).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <TiposUnidadesVista
            tiposUnidadess={tiposUnidadess}
            cargarTiposUnidades={cargarTiposUnidades}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableTiposUnidadesCV;
